import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useFeatureFlagApi } from '../services/api/useFeatureFlag.api';
import { FLAG, FlagName } from '../utils/flags.gen';

interface UseFeatureFlagsResult {
  isEnabled: (flag: FlagName) => boolean;
  isLoading: boolean;
}

export function useFeatureFlags(): UseFeatureFlagsResult {
  const { getFeatureFlags } = useFeatureFlagApi();

  const { data, isLoading } = useQuery({
    queryKey: ['featureFlags'],
    queryFn: getFeatureFlags,
    staleTime: 5 * 60 * 1000,
  });

  const enabledTokens = useMemo(() => new Set(data ?? []), [data]);

  const isEnabled = (flag: FlagName): boolean => enabledTokens.has(FLAG[flag]);

  return { isEnabled, isLoading };
}

export default useFeatureFlags;
